export const calculateRateCostLarrain = (
  amount: number,
  advance: number,
  operationCostFixed: number,
  rate: number,
  days: number,
) => {
  const amountFinanced = amount * (advance / 100);
  const presentValue =
    (amountFinanced + operationCostFixed) / (1 + (rate * days) / 30 / 100);
  return amount - presentValue;
};
